import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

import CoreAlert from 'frontcore/presentation/alert/views/CoreAlert.vue'
import { AlertType } from 'frontcore/presentation/alert/domain/types'
import { PORTAL_LEVELS } from 'frontcore/constants/constants'
import { TOASTS_WRAPPER_ELEMENT_ID } from 'frontcore/presentation/alert/domain/constants'
import { useAlertQueueStore } from 'frontcore/presentation/alert/domain/useAlertQueueStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastsWrapper',
  setup(__props) {

const { alertQueue } = useAlertQueueStore()

return (_ctx: any,_cache: any) => {
  const _component_portal = _resolveComponent("portal")!

  return (_openBlock(), _createBlock(_component_portal, {
    to: _unref(PORTAL_LEVELS).TOASTS,
    order: 1
  }, {
    default: _withCtx(() => [
      _createVNode(_TransitionGroup, {
        id: _unref(TOASTS_WRAPPER_ELEMENT_ID),
        name: "toast-fade",
        tag: "div",
        class: "toasts-wrapper tw-flex tw-flex-col-reverse tw-flex-wrap tw-gap-4 tw-fixed"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alertQueue), (toastMessage) => {
            return (_openBlock(), _createBlock(CoreAlert, {
              key: toastMessage.alertId,
              alertId: toastMessage.alertId,
              status: toastMessage.status,
              message: toastMessage.message,
              type: _unref(AlertType).TOAST
            }, null, 8, ["alertId", "status", "message", "type"]))
          }), 128))
        ], undefined, true),
        _: 1
      }, 8, ["id"])
    ], undefined, true),
    _: 1
  }, 8, ["to"]))
}
}

})